var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component animated-asset",on:{"click":_vm.animate}},[_c('div',{staticClass:"content"},[_vm._t("default")],2),(_vm.debug)?_c('div',{staticClass:"debug"},[_vm._v(" "+_vm._s(_vm.topOffset)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }